import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import reportAPI from "../../../../api/report";
import { FilterYearOnly } from "../common/ReportFilters";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { ExceltCatPICCCEN } from "../../functions/Report.ExportCatPICCCEN";
import { formatDataCatPICCCEN } from "../../utils/Report.Format";
import {
  BARCHART,
  FLEXDROPDOWN,
  SCREENIPAD,
  STYLEBODY,
  STYLEHEAD,
} from "../../../../utils/useStyle";

const ReportCountLabelCatheter = ({ userDept }) => {
  const [loading, setLoading] = React.useState(false);
  const [year, setYear] = React.useState({
    label: "ทุกปี",
    value: "ALL",
  });
  const [type, setType] = React.useState({
    label: "-",
    value: "NONE",
  });

  const [data, setData] = React.useState({
    jan: { picc: 0, central: 0 },
    feb: { picc: 0, central: 0 },
    mar: { picc: 0, central: 0 },
    apr: { picc: 0, central: 0 },
    may: { picc: 0, central: 0 },
    jun: { picc: 0, central: 0 },
    jul: { picc: 0, central: 0 },
    aug: { picc: 0, central: 0 },
    sep: { picc: 0, central: 0 },
    oct: { picc: 0, central: 0 },
    nov: { picc: 0, central: 0 },
    dec: { picc: 0, central: 0 },
  });

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await reportAPI.getLabelCatheterReport({
          year: String(year?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching label catheter report:", error);
      }
    };
    fetchData();
  }, [year, type, userDept]);

  const listTable = [
    { name: "ม.ค.", PICC: data?.jan?.picc, CENTRAL: data?.jan?.central },
    { name: "ก.พ.", PICC: data?.feb?.picc, CENTRAL: data?.feb?.central },
    { name: "มี.ค.", PICC: data?.mar?.picc, CENTRAL: data?.mar?.central },
    { name: "เม.ย.", PICC: data?.apr?.picc, CENTRAL: data?.apr?.central },
    { name: "พ.ค.", PICC: data?.may?.picc, CENTRAL: data?.may?.central },
    { name: "มิ.ย.", PICC: data?.jun?.picc, CENTRAL: data?.jun?.central },
    { name: "ก.ค.", PICC: data?.jul?.picc, CENTRAL: data?.jul?.central },
    { name: "ส.ค.", PICC: data?.aug?.picc, CENTRAL: data?.aug?.central },
    { name: "ก.ย.", PICC: data?.sep?.picc, CENTRAL: data?.sep?.central },
    { name: "ต.ค.", PICC: data?.oct?.picc, CENTRAL: data?.oct?.central },
    { name: "พ.ย.", PICC: data?.nov?.picc, CENTRAL: data?.nov?.central },
    { name: "ธ.ค.", PICC: data?.dec?.picc, CENTRAL: data?.dec?.central },
  ];

  return (
    <div>
      _____________________________________________________________________________________
      <div className={``}>
        <div className="my-20">
          <div className={SCREENIPAD}>
            <> </>
            <div className={STYLEHEAD}>
              นับชนิดของสายน้ำเกลือที่ใส่แต่ละปี แยกตามเดือน
              <div className={STYLEBODY}>ของปี " {year?.label}"</div>
            </div>
            <div className={FLEXDROPDOWN}>
              <FilterYearOnly year={year} setYear={setYear} />
              <ButtonExcel
                onClick={() => {
                  ExceltCatPICCCEN(
                    formatDataCatPICCCEN(data),
                    year,
                    setLoading
                  );
                }}
                loading={loading}
              />
            </div>
          </div>
          <div className={BARCHART}>
            <BarChart
              width={700}
              height={300}
              data={listTable}
              margin={{
                top: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar label={{ fill: "#111827" }} dataKey="PICC" fill="#86efac" />
              <Bar
                label={{ fill: "#111827" }}
                dataKey="CENTRAL"
                fill="#bbf7d0"
              />
            </BarChart>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportCountLabelCatheter;
